import { SVGProps } from 'react';

export const IconChevron = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox='0 0 20 20' fill='none'>
      <path d='M12 14L8 10L12 6' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
};
